import classNames from "classnames";
import PropTypes from "prop-types";
import React, { forwardRef } from "react";

/**
 * @param {JSX.node} children The content.
 * @param {string} [className] Extra class.
 * @returns {JSX.Element} The element.
 */
const Header = /*#__PURE__*/forwardRef(({
  children,
  className
}, ref) => /*#__PURE__*/React.createElement("div", {
  ref: ref,
  className: classNames("yst-modal__container-header", className)
}, children));
Header.displayName = "Modal.Container.Header";
Header.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};
Header.defaultProps = {
  className: ""
};

/**
 * @param {JSX.node} children The content.
 * @param {string} [className] Extra class.
 * @returns {JSX.Element} The element.
 */
const Content = /*#__PURE__*/forwardRef(({
  children,
  className
}, ref) => /*#__PURE__*/React.createElement("div", {
  ref: ref,
  className: classNames("yst-modal__container-content", className)
}, children));
Content.displayName = "Modal.Container.Content";
Content.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};
Content.defaultProps = {
  className: ""
};

/**
 * @param {JSX.node} children The content.
 * @param {string} [className] Extra class.
 * @returns {JSX.Element} The element.
 */
const Footer = /*#__PURE__*/forwardRef(({
  children,
  className
}, ref) => /*#__PURE__*/React.createElement("div", {
  ref: ref,
  className: classNames("yst-modal__container-footer", className)
}, children));
Footer.displayName = "Modal.Container.Footer";
Footer.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};
Footer.defaultProps = {
  className: ""
};

/**
 * @param {JSX.node} children The content.
 * @param {string} [className] Extra class.
 * @returns {JSX.Element} The element.
 */
export const Container = /*#__PURE__*/forwardRef(({
  children,
  className
}, ref) => /*#__PURE__*/React.createElement("div", {
  ref: ref,
  className: classNames("yst-modal__container", className)
}, children));
Container.displayName = "Modal.Container";
Container.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};
Container.defaultProps = {
  className: ""
};
Container.Header = Header;
Container.Content = Content;
Container.Footer = Footer;